import React from "react";
import "../../css/components/Navbar.css";
import logo from "../../assets/images/FG Wealth Advisory Logo.png";
import SecondaryButton from "./buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "./buttons/PrimaryButton";

// Example lists (replace with your actual data if different)
const servicesList = [
  { name: "Investments", path: "/investments" },
  { name: "Pensions", path: "/pensions" },
  { name: "Protection", path: "/protection" },
  { name: "Equity Release", path: "/equity-release" },
  { name: "Blog", path: "/blog" },
  { name: "Charity", path: "/charity" },
  { name: "FAQ", path: "/faq" },
];
// const calculatorsList = [
//   { name: "Mortgage Calculator", path: "/calculators/mortgage" },
//   { name: "Retirement Calculator", path: "/calculators/retirement" },
// ];

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logo}
          alt="FG Wealth Advisory Logo"
          className="navbar-logo"
          onClick={() => {
            navigate("/");
          }}
        />
      </div>
      <ul className="navbar-links">
        <li>
          <span className="button-text" onClick={() => navigate("/about-us")}>
            About Us
          </span>
        </li>
        {/* Individual Service Links */}
        {servicesList.map((service) => (
          <li key={service.name}>
            <span
              className="button-text"
              onClick={() => navigate(service.path)}
            >
              {service.name}
            </span>
          </li>
        ))}
        {/* Individual Calculator Links */}
        {/* {calculatorsList.map((calc) => (
          <li key={calc.name}>
            <span className="button-text" onClick={() => navigate(calc.path)}>
              {calc.name}
            </span>
          </li>
        ))} */}
        {/* <li>
          <span className="button-text" onClick={() => navigate("/faqs")}>
            FAQ
          </span>
        </li> */}
      </ul>
      <div className="navbar-right" >
        <SecondaryButton
          onClick={() => navigate("/calculators")}
          text="Calculators"
        />
        <PrimaryButton onClick={() => navigate("/contact-us")} text="Contact" />
      </div>
    </nav>
  );
};

export default Navbar;
